<template>
    <div class="vue-horizontal-slot-scroller">
        <div class="inner">
          <div class="row">
            <div class="col-12">

                <div class="title-wrapper">

                    <slot name="title"></slot>

                </div>

                <div class="scroller-content-wrapper">
                <perfect-scrollbar>

                  <slot name="products"></slot>

                </perfect-scrollbar>
              </div>
            </div>
          </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "HorizontalSlotScroll",
}
</script>